export const GlobalServicesEnums = {
  profileKeys: {
    GLOBAL_SERVICES: 'global_services', // used by superadmin config
    GLOBAL_SERVICES_PROFILES: 'global_services_profiles' // used by admin config
  },
  routeKeys: {
    CREATE: 'create',
    READ: 'read',
    UPDATE_BY_ID: 'update_by_id',
    DELETE_BY_ID: 'delete_by_id'
  },
  categories: [
    {
      label: 'Consultations',
      value: 'consultations',
      color: '#1890ff',
      icon: '🩺'
    },
    {
      label: 'Blood Tests',
      value: 'blood_tests',
      color: '#722ed1',
      icon: '🔬'
    },
    {
      label: 'Diagnostics',
      value: 'diagnostics',
      color: '#13c2c2',
      icon: '📊'
    },
    {
      label: 'Vaccinations & Immunisations',
      value: 'vaccinations_immunisations',
      color: '#52c41a',
      icon: '💉'
    },
    {
      label: 'IV Therapy',
      value: 'iv_therapy',
      color: '#1890ff',
      icon: '💧'
    },
    {
      label: 'Health & Wellness',
      value: 'health_wellness',
      color: '#eb2f96',
      icon: '🏥'
    },
    {
      label: 'Therapies',
      value: 'therapies',
      color: '#722ed1',
      icon: '🧘'
    },
    {
      label: 'Medication Administration',
      value: 'medication_administration',
      color: '#f5222d',
      icon: '💊'
    },
    {
      label: 'Home & Onsite Visits',
      value: 'home_onsite_visits',
      color: '#faad14',
      icon: '🏠'
    },
    {
      label: 'Administrative Services',
      value: 'administrative_services',
      color: '#52c41a',
      icon: '📋'
    },
    {
      label: 'Telehealth & Virtual Care',
      value: 'telehealth_virtual_care',
      color: '#13c2c2',
      icon: '💻'
    },
    {
      label: 'Specialist Services',
      value: 'specialist_services',
      color: '#fa541c',
      icon: '👨‍⚕️'
    },
    {
      label: 'Minor Procedures',
      value: 'minor_procedures',
      color: '#fa541c',
      icon: '🔧'
    }
  ]
}
